"use client";

import { useState, useEffect } from "react";
import { getPublicSchoolImages, SchoolImage } from "@/app/lib/api/school-images";
import { SafeImage } from "@/app/components/SafeImage";
import { Loader2 } from "lucide-react";

export default function OkulAlbumleriPage() {
  const [schoolImages, setSchoolImages] = useState<SchoolImage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSchoolImages = async () => {
      try {
        setLoading(true);
        setError(null);
        const images = await getPublicSchoolImages();
        setSchoolImages(images);
      } catch (err) {
        setError("Okul resimleri yüklenirken bir hata oluştu.");
        console.error("Error fetching school images:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSchoolImages();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center space-x-2">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span>Okul albumleri yükleniyor...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Tekrar Dene
          </button>
        </div>
      </div>
    );
  }

  if (schoolImages.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 text-lg">Henüz okul resmi bulunmuyor.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-12 px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {schoolImages.map((image) => (
            <div
              key={image.id}
              className="group transform transition-all duration-300"
            >
              <div className="relative aspect-[1143/1600] bg-gray-200 rounded-lg overflow-hidden shadow-md transition-all group-hover:shadow-lg">
                <SafeImage
                  src={image.image_url}
                  alt="Okul resmi"
                  fill
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  className="object-cover duration-300"
                  priority={image.id <= 6}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}